class StateConstants {
    static ADDRESS_STATE = "address"
    static AUTOSUGGEST_QUOTA_LIMIT_REACHED = "quotaLimitReached"
    static SUGGESTIONS_STATE = "suggestions"
    static SHOW_SUGGESTIONS = "showSuggestions"
    static RELATIVE_CONDITION = "rc"
    static REMOVED_HOMES = "removedHomes"
    static ADVANCED_OPTIONS = "advancedOptions"
    static SHOULD_UPDATE_VALUATION = "shouldUpdateValuation"
    static IS_LOADING = "isLoading"
    static VALUATION_LOADING = "valuationLoading"
    static STATE_UPDATE_COUNT = "stateUpdateCount"
    static ERROR = "error"
    static IS_GOOGLE_BOT = "isGoogleBot"
    static SHOW_TIME_SERIES = "showTimeSeries"
    static IS_MOBILE = "isMobile"

    static IS_LOGGED_IN = "isLoggedIn"
    static SHOW_ACCOUNT_PANEL = "showAccountPanel"
    static CURRENT_PAGE_STATE = "currentPageState"

    static COMPARABLE_HOMES_STATE = "comparableHomes"
    static VALUATION_STATE = "valuation"
    static SAVED_VALUATIONS = "savedValuations"
    static AREA_SIGNALS_STATE = "areaSignals"

    static MAP_MARKER_HOVER = "mapMarkerHover"
    static MAP_MARKER_CLICK = "mapMarkerClick"

    static VALUATION_COMPLETE_STATE = "valuationComplete"

    static AREA_SEARCH_STATE = "areaSearch"
    static AREA_SUGGESTIONS_STATE = "areaSuggestions"
    static SHOW_AREA_SUGGESTIONS = "showAreaSuggestions"
    static AREA_STATE = "area"

    static VALUATION_USAGE = "valuationUsage"

    static IS_PREMIUM = "isPremium"
    static SHOW_PLAN_MODAL = "showPlanModal"
    static PLAN_MODAL_VARIANT = "planModalVariant"
    static PLAN_MODAL_PROPERTY_ID = "planModalPropertyId"
    static PLAN_MODAL_ADDRESS = "planModalAddress"
    static SHOW_LOGIN_MODAL = "showLoginModal"
    static LOGIN_MODAL_MODE = "loginModalMode"
    static PENDING_PAYMENT_INTENT_ID = "pendingPaymentIntentId"
    static CURRENT_PROPERTY_ID = "currentPropertyId"
    static PENDING_FREE_VALUATION_PROPERTY_ID = "pendingFreeValuationPropertyId"
    static ACCOUNT_TYPE = "accountType"
    static USER_EMAIL = "userEmail"
    static USER_FEATURES = "userFeatures"
    static USER_PERMISSIONS = "userPermissions"
    static USER_ROLE = "userRole"
    static FREE_DETAILED_VALUATION_CREDITS_REMAINING = "freeDetailedValuationCreditsRemaining"
    static FREE_UNLOCKED_PROPERTY_IDS = "freeUnlockedPropertyIds"
    static PENDING_SAVE_VALUATION_PAYLOAD = "pendingSaveValuationPayload"
    static SUBSCRIPTION = "subscription"
    static SUBSCRIPTION_RETURN_STATUS = "subscriptionReturnStatus"
    static PROPERTY_UNLOCK_RETURN_STATUS = "propertyUnlockReturnStatus"
}

export default StateConstants
